let viewgird = [
  // 巡检
  {
    path: '/Air_RoutineTmp',
    name: 'Air_RoutineTmp',
    component: () => import('@/views/device/air/Air_RoutineTmp.vue')
  },
  {
    path: '/Air_RoutineTmpDet',
    name: 'Air_RoutineTmpDet',
    component: () => import('@/views/device/air/Air_RoutineTmpDet.vue')
  },
  {
    path: '/Air_RoutineConfig',
    name: 'Air_RoutineConfig',
    component: () => import('@/views/device/air/Air_RoutineConfig.vue')
  },
  {
    path: '/Air_RoutineConfigDet',
    name: 'Air_RoutineConfigDet',
    component: () => import('@/views/device/air/Air_RoutineConfigDet.vue')
  },
  {
    path: '/Air_RoutineInspection',
    name: 'Air_RoutineInspection',
    component: () => import('@/views/device/air/Air_RoutineInspection.vue')
  },
  {
    path: '/Air_RoutineDetail',
    name: 'Air_RoutineDetail',
    component: () => import('@/views/device/air/Air_RoutineDetail.vue')
  },
  {
    path: '/Air_RoutineView',
    name: 'Air_RoutineView',
    component: () => import('@/views/device/air/Air_RoutineView.vue')
  },
  //售后管理-设备监测
  {
    path: '/Ser_DeviceMan',
    name: 'Ser_DeviceMan',
    component: () => import('@/views/servicing/Ser_DeviceMan.vue')
  },
  //售后管理-设备监测点击【出厂编号】跳转设备详情
  {
    path: '/Ser_EquipmentDetail',
    name: 'Ser_EquipmentDetail',
    component: () => import('@/views/servicing/Ser_EquipmentDetail.vue')
  },
  //售后管理-设备监测点击【客商名称】跳转客商详情
  {
    path: '/Ser_CustomerDetail',
    name: 'Ser_CustomerDetail',
    component: () => import('@/views/servicing/Ser_CustomerDetail.vue')
  },
  {
    path: '/Air_CustomerMaster',
    name: 'Air_CustomerMaster',
    component: () => import('@/views/device/air/Air_CustomerMaster.vue')
  },
  {
    path: '/Air_SalesContract',
    name: 'Air_SalesContract',
    component: () => import('@/views/device/air/Air_SalesContract.vue')
  },
  {
    path: '/Air_SalesOrder',
    name: 'Air_SalesOrder',
    component: () => import('@/views/device/air/Air_SalesOrder.vue')
  },
  {
    path: '/Air_Shipment',
    name: 'Air_Shipment',
    component: () => import('@/views/device/air/Air_Shipment.vue')
  },
  {
    path: '/Air_ReturnOrder',
    name: 'Air_ReturnOrder',
    component: () => import('@/views/device/air/Air_ReturnOrder.vue')
  },
  {
    path: '/Air_Receipt',
    name: 'Air_Receipt',
    component: () => import('@/views/device/air/Air_Receipt.vue')
  },
  {
    path: '/Air_ReceiveRefund',
    name: 'Air_ReceiveRefund',
    component: () => import('@/views/device/air/Air_ReceiveRefund.vue')
  },
  {
    path: '/Air_Invoice',
    name: 'Air_Invoice',
    component: () => import('@/views/device/air/Air_Invoice.vue')
  },
  {
    path: '/Air_SignConfirm',
    name: 'Air_SignConfirm',
    component: () => import('@/views/device/air/Air_SignConfirm.vue')
  },
  {
    path: '/Air_SalesOut',
    name: 'Air_SalesOut',
    component: () => import('@/views/device/air/Air_SalesOut.vue')
  },
  {
    path: '/Air_StoreProRecord',
    name: 'Air_StoreProRecord',
    component: () => import('@/views/device/air/Air_StoreProRecord.vue')
  },
  {
    path: '/Air_ProductionOrder',
    name: 'Air_ProductionOrder',
    component: () => import('@/views/device/air/Air_ProductionOrder.vue')
  },
  {
    path: '/Air_Equipment',
    name: 'Air_Equipment',
    component: () => import('@/views/device/air/Air_Equipment.vue')
  },
  {
    path: '/Air_CustomerContact',
    name: 'Air_CustomerContact',
    component: () => import('@/views/device/air/Air_CustomerContact.vue')
  },
  {
    path: '/Air_CustomerDetail',
    name: 'Air_CustomerDetail',
    component: () => import('@/views/device/air/Air_CustomerDetail.vue')
  },
  {
    path: '/Air_CustomerEquipment',
    name: 'Air_CustomerEquipment',
    component: () => import('@/views/device/air/Air_CustomerEquipment.vue')
  },
  {
    path: '/Air_MaterialDetail',
    name: 'Air_MaterialDetail',
    component: () => import('@/views/device/air/Air_MaterialDetail.vue')
  },
  {
    path: '/Air_CustomerShippingAddress',
    name: 'Air_CustomerShippingAddress',
    component: () => import('@/views/device/air/Air_CustomerShippingAddress.vue')
  },
  {
    path: '/Air_MaterialCategory',
    name: 'Air_MaterialCategory',
    component: () => import('@/views/device/air/Air_MaterialCategory.vue')
  },
  {
    path: '/Air_PartPrice',
    name: 'Air_PartPrice',
    component: () => import('@/views/device/air/Air_PartPrice.vue')
  },
  {
    path: '/Air_DeviceBatch',
    name: 'Air_DeviceBatch',
    component: () => import('@/views/device/air/Air_DeviceBatch.vue')
  },
  {
    path: '/Air_DeviceBatchMaintainLog',
    name: 'Air_DeviceBatchMaintainLog',
    component: () => import('@/views/device/air/Air_DeviceBatchMaintainLog.vue')
  },
  {
    path: '/Air_DeviceBind_File',
    name: 'Air_DeviceBind_File',
    component: () => import('@/views/device/air/Air_DeviceBind_File.vue')
  },
  {
    path: '/Air_DeviceInfo',
    name: 'Air_DeviceInfo',
    component: () => import('@/views/device/air/Air_DeviceInfo.vue')
  },
  {
    path: '/Air_PartStock',
    name: 'Air_PartStock',
    component: () => import('@/views/device/air/Air_PartStock.vue')
  },
  {
    path: '/SalesContractDetail',
    name: 'SalesContractDetail',
    component: () => import('@/views/device/air/SalesContractDetail.vue')
  },
  {
    path: '/SalesContractForm',
    name: 'SalesContractForm',
    component: () => import('@/views/device/air/SalesContractForm.vue')
  },
  {
    path: '/SalesOrderDetail',
    name: 'SalesOrderDetail',
    component: () => import('@/views/device/air/SalesOrderDetail.vue')
  },
  {
    path: '/ShipmentDetail',
    name: 'ShipmentDetail',
    component: () => import('@/views/device/air/ShipmentDetail.vue')
  },
  {
    path: '/ReturnOrderDetail',
    name: 'ReturnOrderDetail',
    component: () => import('@/views/device/air/ReturnOrderDetail.vue')
  },
  {
    path: '/ReceiptDetail',
    name: 'ReceiptDetail',
    component: () => import('@/views/device/air/ReceiptDetail.vue')
  },
  {
    path: '/ReceiveRefundDetail',
    name: 'ReceiveRefundDetail',
    component: () => import('@/views/device/air/ReceiveRefundDetail.vue')
  },
  {
    path: '/InvoiceDetail',
    name: 'InvoiceDetail',
    component: () => import('@/views/device/air/InvoiceDetail.vue')
  },
  {
    path: '/SignConfirmDetail',
    name: 'SignConfirmDetail',
    component: () => import('@/views/device/air/SignConfirmDetail.vue')
  },
  {
    path: '/SalesOutDetail',
    name: 'SalesOutDetail',
    component: () => import('@/views/device/air/SalesOutDetail.vue')
  },
  {
    path: '/StoreProRecordDetail',
    name: 'StoreProRecordDetail',
    component: () => import('@/views/device/air/StoreProRecordDetail.vue')
  },
  {
    path: '/ProductionOrderDetail',
    name: 'ProductionOrderDetail',
    component: () => import('@/views/device/air/ProductionOrderDetail.vue')
  },
];

export default viewgird;
